import { MT4Connector, TradeCommandType } from '@bdswiss/mt4-connector'
import { connect } from 'react-redux'
import { setTradingSignal, setTradingSymbol } from '../actions/commonActions'
import { RootState } from '../types'
import { TradingAction } from '../actions'
import AssetSignalsTable from '../components/AssetSignalsTable'
import { Dispatch } from 'redux'
const mt4 = MT4Connector.Instance

function mapDispatchToProps(dispatch: Dispatch<TradingAction>) {
  return {
    onSetSignal: (signal: any) => {
      dispatch(setTradingSignal(signal))
    },
    onSetTradingSymbol: (symbol: string, type: TradeCommandType) => {
      dispatch(setTradingSymbol(symbol, type))
    },
  }
}

function mapStateToProps(rootState: RootState) {
  const state = rootState.appState
  return {
    // symbol: state.symbol,
    assets: mt4.assets,
    allSignals: mt4.tradeableSignals, //rootState.signals,
    signal: state.signal,
  }
}

export const AssetSignalsTableContentContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(AssetSignalsTable)
